import styles from "../../styles/image-upload.module.scss";
import { Icon } from "../../shared/components/core/Icon";
import { useState } from "react";

export const TextFileReaderIfood = ({ onFileLoaded, filePattern, allowedFiles }) => {
  const [loading, setLoading] = useState(false);

  const handleSetFile = async (e) => {
    const file = e.target.files[0];

    if (file) {
      const fileType = file.type;
      if (filePattern && !fileType.match(filePattern)) {
        alert({ text: "Arquivo inválido." });
        return false;
      }

      let reader = new FileReader();
      setLoading(true);

      reader.onload = async (readerEvent) => {
        onFileLoaded({
          name: file.name,
          content: readerEvent.target.result,
        });
        setLoading(false);
      };
      reader.readAsText(file);
    }
  };

  return (
    <div className="d-flex align-center">
      <label htmlFor="picture" className={styles.customFileInput}>
        {loading ? (
          <div className={styles.loading}>
            <span className={styles.loader}></span>
          </div>
        ) : (
          <span className={styles.plus}>
            <Icon name="plus" color="#fff" />
          </span>
        )}
        <input
          type="file"
          id="picture"
          accept={allowedFiles || "text/*"}
          onChange={(e) => handleSetFile(e)}
        />
      </label>
    </div>
  );
};
